import { Box, styled, Typography } from '@mui/material';
import { HFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';
import { StepperVariant } from '../../types/stepper';

export const RootContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'stepperType',
})<{
  stepperType: StepperVariant;
}>`
  width: 100%;
  max-width: ${(props) => (props.stepperType === StepperVariant.BAR ? '257px' : 'unset')};
`;

export const InfoContainer = styled(HFlex)`
  justify-content: space-between;
  align-items: center;
`;

export const InfoText = styled(Typography)`
  color: ${palette.custom.darkGrey};
  text-transform: uppercase;
  font-weight: 700;
  font-family: trade-gothic-next-condensed, sans-serif;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
`;
